import { z } from 'zod/v4';

import {
  columns,
  constantValueColumns,
  planningLeadTimeColumns,
  quantityAwareColumns,
  rafFixedMarketColumns,
} from './columns';

export const leadTimeConfigBaseSchema = z.object(columns);

export const leadTimeConfigSchema = z.discriminatedUnion('leadTimeType', [
  z.object({ ...columns, ...constantValueColumns.shape }),
  z.object({ ...columns, ...planningLeadTimeColumns.shape }),
  z.object({ ...columns, ...rafFixedMarketColumns.shape }),
  z.object({ ...columns, ...quantityAwareColumns.shape }),
]);

export type LeadTimeConfig = z.output<typeof leadTimeConfigSchema>;

export const leadTimeConfigUpdateBaseSchema = leadTimeConfigBaseSchema.pick({
  sortOrder: true,
});

export const leadTimeConfigUpdateSchema = z.discriminatedUnion('leadTimeType', [
  z.object({
    ...leadTimeConfigUpdateBaseSchema.shape,
    ...constantValueColumns.shape,
  }),
  z.object({
    ...leadTimeConfigUpdateBaseSchema.shape,
    ...planningLeadTimeColumns.shape,
  }),
  z.object({
    ...leadTimeConfigUpdateBaseSchema.shape,
    ...rafFixedMarketColumns.shape,
  }),
  z.object({
    ...leadTimeConfigUpdateBaseSchema.shape,
    ...quantityAwareColumns.shape,
  }),
]);
